import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const farmCropDailyTasks = createAsyncThunk('farmCropDailyTasks', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `work-farm-crops/schedule/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const farmCropDailyTasksSlice = createSlice({
    name: 'farmCropDailyTasks',
    initialState: {
        data: [],
        schedule_status: '',
    },
    reducers: {
        clearFarmCropDailyTasks: (state) => {
            state.data = [];
            state.schedule_status = '';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(farmCropDailyTasks.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data?.data ?? [];
                state.schedule_status = action.payload.data?.schedule_status ?? '';
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
                state.schedule_status = '';
            }

        });
        builder.addCase(farmCropDailyTasks.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { clearFarmCropDailyTasks } = farmCropDailyTasksSlice.actions;
export default farmCropDailyTasksSlice.reducer;
